import { LinkIntegrationMetadataForType } from '@modules/integrationsV2/components/LinkIntegrationMetadata/LinkIntegrationMetadataForType';
import { LinkIntegrationMetadataHeader } from '@modules/integrationsV2/components/LinkIntegrationMetadata/LinkIntegrationMetadataHeader';
import { IntegrationSource } from '@modules/integrationsV2/types';
import {
  getLinkableIntegrationTypes,
  trackIntegrationPageEvent,
} from '@modules/integrationsV2/utils';
import { ExpandMoreRounded } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Stack,
} from '@mui/material';
import { IntegrationType, IntegrationViewFragment } from 'generated/graphql';
import { Fragment, useState } from 'react';

interface LinkIntegrationMetadataProps {
  integrations: IntegrationViewFragment[];
  integrationSource: IntegrationSource;
}

export const LinkIntegrationMetadata = ({
  integrations,
  integrationSource,
}: LinkIntegrationMetadataProps) => {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

  // We are not supporting linking cohorts to other integrations yet
  if (integrationSource.integrationType === IntegrationType.Cohorts) {
    return null;
  }

  const linkableIntegrationTypes = getLinkableIntegrationTypes(
    integrationSource.integrationType,
  );

  const handleAccordionChange = (
    _: React.SyntheticEvent<Element, Event>,
    isExpanded: boolean,
  ) => {
    setIsAccordionExpanded(isExpanded);
    if (isExpanded) {
      trackIntegrationPageEvent({
        eventName: 'Integrations - Link Integrations Card Expanded',
        integration: {
          channelType: integrationSource.channel.type,
          integrationType: integrationSource.integrationType,
          namespace: integrationSource.namespace,
        },
      });
    }
  };

  return (
    <Box>
      <Accordion
        disableGutters
        variant="outlined"
        expanded={isAccordionExpanded}
        onChange={handleAccordionChange}
        sx={{
          pt: 1,
          pb: isAccordionExpanded ? 0 : 1,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreRounded fontSize="large" />}>
          <LinkIntegrationMetadataHeader
            integrationSource={integrationSource}
          />
        </AccordionSummary>
        <AccordionDetails>
          {isAccordionExpanded && (
            <Stack>
              {linkableIntegrationTypes.map((integrationType, index) => {
                return (
                  <Fragment key={integrationType}>
                    {index !== 0 && <Divider />}
                    <LinkIntegrationMetadataForType
                      integrationType={integrationType}
                      integrationSource={integrationSource}
                      integrations={integrations}
                    />
                  </Fragment>
                );
              })}
            </Stack>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
